import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WellComponent } from '@src/shared/presentational/well/well.component';
import { InlineGroupComponent } from '@src/shared/structural/inline-group/inline-group.component';
import { WooComponentsModule } from '../../scripts/woo_components.module/module';
import { DotLoader } from '../../src/shared/feedback/loader/dot-loader.component';
import { WooTabComponent } from '../../src/shared/navigation/woo-tabs/woo-tab/woo-tab.component';
import { WooTabsComponent } from '../../src/shared/navigation/woo-tabs/woo-tabs.component';
import { WooCodeComponent } from '../../src/shared/presentational/woo-code/woo-code.component';
import { CampaignRowCard } from './components/campaign-row-card.component';
import { CampaignRowList } from './components/campaign-row-list.component';
import { EosAggregations } from './components/eos-aggregations.component';
import { EosApiTester } from './components/eos-api-tester.component';
import { Eos } from './components/eos.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WooCodeComponent,
    WooTabsComponent,
    WooTabComponent,
    DotLoader,
    WooComponentsModule,
    WellComponent,
    InlineGroupComponent,
  ],
  declarations: [CampaignRowList, CampaignRowCard, Eos, EosAggregations, EosApiTester],
  exports: [Eos],
})
export class WooEos {}
